import { useState, useEffect } from "react";
import { DrawerComponent, Modal } from "src/components/DialogComponent";
import Button from "src/components/Button";
import TGButton from "src/components/ui/TGButton";
import { useAppDispatch, useAppSelector } from "src/hooks/redux";
import _ from "lodash";
import { addItemRequest, deleteItemRequest, updateItemRequest, getItemsRequest } from "src/modules/spItems/api";
import { selectCurrentUser, selectUsers } from "src/modules/users/selector";
import Form from "src/components/Form";
import { selectItems } from "src/modules/spItems/selectors";
import { myTasksIncidentstListName, myTasksIncidentsQuestionsListName, myTasksTypeIncidentsListName } from "src/api/config/myTasksInc.config";
import { myTasksDependListName, myTasksLocationsListName } from "src/api/config/myTasksLists.config";
import { getItems } from "src/modules/spItems/actions";
import moment from "moment";
import { useSearchParams, useNavigate } from "react-router-dom";
import LoadingOpBg from "src/components/LoadingOpBg";
import { equipmentsListName, paramsListName } from "src/api/config";
import {
    incStatus,
    incTrigger,
    incTypes,
    nTrigger,
} from "src/api/config/systemSwitch";
import { autoCloseModal } from "src/constants";

const taskCardButtonClassName =
  "block w-full bg-transparent px-[28px] py-[16px] text-center font-normal leading-none tracking-normal text-darkblue hover:bg-[#F4F6FC]";

const AddIncident = ({ zIndex, fromTaskCard = false }: { zIndex: number, fromTaskCard?: boolean }) => {
    const dispatch = useAppDispatch();
    const currentUser: any = useAppSelector((state) => selectCurrentUser(state));
    const [open, setOpen] = useState(false);
    const [cancel, setCancel] = useState(false);
    const [addInc, setAddInc] = useState(false);
    const [closeAllModals, setCloseAllModals] = useState(false);
    const [fields, setFields] = useState<any>([]);
    const [dependenceFields, setDependenceFields] = useState<any>({
        Location: null,
        Department: null,
        Region: null
    });
    const [formData, setFormData] = useState<any>(null);
    const [defaultValues, setDefaultValues] = useState<any>({
        DateIncidents: { startDate: new Date(), endDate: new Date() },
        DateIncidents2: { startDate: new Date(), endDate: new Date() }
    });

    const users: any = useAppSelector(selectUsers);
    const [createIncID, setCreateIncID] = useState<any>(0);
    const [removeInc, setRemoveInc] = useState(false);

    const [customLoading, setCustomLoading] = useState(false);
    const [incQuestions, setIncQuestions] = useState<any>([]);

    const locations: any = useAppSelector(state => selectItems(state, myTasksLocationsListName));
    const dependencies: any = useAppSelector(state => selectItems(state, myTasksDependListName));
    const typesIncList: any = useAppSelector(state => selectItems(state, myTasksTypeIncidentsListName));
    const [incIDAdd, setIncIDAdd] = useState<any>(null);
    const [query, setQuery] = useSearchParams();
    const [renderInc, setRenderInc] = useState(false);
    const [incKeys, setIncKeys] = useState<any>([]);
    const [currentTypeInc, setCurrentTypeInc] = useState<any>('Безопасность');
    const [typesInc, setTypesInc] = useState<any>([]);
    const [currentFormData, setCurrentFormData] = useState<any>(null);
    const navigate = useNavigate();
    const params: any = useAppSelector((state) => selectItems(state, paramsListName));

    useEffect(() => {
        if (locations.length > 0 && currentUser.id && renderInc) {
            let defaultLocationsIds: number[] = [];
            if (
                currentUser.isLocationAdminMyTasks ||
                currentUser.isLocationEditorMyTasks
            ) {
                if (
                    Array.isArray(currentUser.isLocationAdminMyTasks) &&
                    currentUser.isLocationAdminMyTasks.length > 0
                ) {
                    defaultLocationsIds = [
                        ...defaultLocationsIds,
                        ...currentUser.isLocationAdminMyTasks,
                    ];
                }
                if (
                    Array.isArray(currentUser.isLocationEditorMyTasks) &&
                    currentUser.isLocationEditorMyTasks.length > 0
                ) {
                    defaultLocationsIds = [
                        ...defaultLocationsIds,
                        ...currentUser.isLocationEditorMyTasks,
                    ];
                }
            }
            const unicDefaultLocationsIds: number[] = [
                ..._.uniqWith(defaultLocationsIds, _.isEqual),
            ];
            setDefaultValues((prev: any) => {
                return {
                    ...prev,
                    Location:
                        (currentFormData &&
                            Object.keys(currentFormData).length > 0 &&
                            currentFormData.Location) ||
                        (unicDefaultLocationsIds.length > 0 &&
                            unicDefaultLocationsIds.map((id) => {
                                return {
                                    id: id,
                                    name: locations.find((location: any) => location.ID === id)[
                                        "Title"
                                    ],
                                    disabled: false,
                                };
                            })[0]) ||
                        null,
                    TypeIncident: currentTypeInc,
                    Responsible: [
                        {
                            value: currentUser.email,
                            label: currentUser.displayName,
                            avatar: currentUser.avatar,
                            email: currentUser.email,
                        },
                    ],
                };
            });
        }
    }, [locations, currentUser, renderInc, currentTypeInc]);

    //Расставляем опции селектов локации, типа сотрудников
    useEffect(() => {
        if (currentUser.id && renderInc) {
            const tempFieldsForm = [...fields];
            for (let i = 0; i < tempFieldsForm.length; i++) {
                if (tempFieldsForm[i]['key'] === 'Location') {
                    const options = locations.filter((location: any) => {
                        if (
                        currentUser.isAdmin ||
                        (currentUser.isLocationEditorMyTasks &&
                            currentUser.isLocationEditorMyTasks.length > 0 &&
                            currentUser.isLocationEditorMyTasks.find(
                            (locationID: any) => locationID === location.ID
                            )) ||
                        (currentUser.isLocationAdminMyTasks &&
                            currentUser.isLocationAdminMyTasks.length > 0 &&
                            currentUser.isLocationAdminMyTasks.find(
                            (locationID: any) => locationID === location.ID
                            ))
                        ) {
                        return true
                        } else {
                        return false
                        }
                    }).map((location: any) => {
                        return {
                        id: location.ID,
                        name: location.Title,
                        available: true,
                        };
                    });
                    tempFieldsForm[i]['options'] = [...options];
                }
                if (tempFieldsForm[i]['key'] === 'TypeIncident') {
                    tempFieldsForm[i]['optionsInputs'] = typesInc.map((type: any) => type.Title.trim()) || []
                }
            }
            setFields([...tempFieldsForm]);
        }
    }, [locations, currentUser, renderInc, typesInc]);

    useEffect(() => {
        if (typesIncList.length > 0) {
            // Hide "Security" from mobile type selector.
            setTypesInc(typesIncList.filter((type: any) => type.ID !== incTypes.security));
        }
    }, [typesIncList]);

    useEffect(() => {
        if (dependenceFields["Location"] && renderInc) {
            dispatch(getItems({ listName: myTasksDependListName, filters: { Location: dependenceFields["Location"]["id"] } }));
            const tempFieldsForm = [...fields];
            for (let i = 0; i < tempFieldsForm.length; i++) {
                if (tempFieldsForm[i]["key"] === "Department") {
                    tempFieldsForm[i]["disabled"] = false;
                }
                if (tempFieldsForm[i]["key"] === "Region") {
                    tempFieldsForm[i]["disabled"] = true;
                }
            }
            setFields([...tempFieldsForm]);
        }
        if (!dependenceFields["Location"] && renderInc) {
            const tempFieldsForm = [...fields];
            for (let i = 0; i < tempFieldsForm.length; i++) {
                if (tempFieldsForm[i]["key"] === "Department" || tempFieldsForm[i]["key"] === "Region") {
                    tempFieldsForm[i]["disabled"] = true;
                }
            }
            setFields([...tempFieldsForm]);
        }
        if (dependenceFields["Department"] && renderInc) {
            const tempFieldsForm = [...fields];
            for (let i = 0; i < tempFieldsForm.length; i++) {
                if (tempFieldsForm[i]["key"] === "Region") {
                    tempFieldsForm[i]["disabled"] = false;
                }
            }
            setFields([...tempFieldsForm]);
        }
    }, [dependenceFields, renderInc]);

    //В списке зависимостей колонка называется Departament, а в списках с аудитами и отделами Department (буква a отличие)

    useEffect(() => {
        if (renderInc) {
            const tempFieldsForm = [...fields];
            for (let i = 0; i < tempFieldsForm.length; i++) {
                if (dependenceFields["Location"]) {
                    if (tempFieldsForm[i]["key"] === "Department") {
                        const options = dependencies
                            .filter((dependence: any) => dependence.Location.ID === dependenceFields["Location"]["id"])
                            .map((dependence: any) => {
                                return {
                                    id: dependence.Departament.ID,
                                    name: dependence.Departament.Title,
                                };
                            });
                        tempFieldsForm[i]["options"] = _.uniqWith(options, _.isEqual);
                    }
                }
                if (dependenceFields["Department"]) {
                    if (tempFieldsForm[i]["key"] === "Region") {
                        const options = dependencies
                            .filter((dependence: any) => dependence.Location.ID === dependenceFields["Location"]["id"] && dependence.Departament.ID === dependenceFields["Department"]["id"])
                            .map((dependence: any) => {
                                return {
                                    id: dependence.Region.ID,
                                    name: dependence.Region.Title,
                                };
                            });
                        tempFieldsForm[i]["options"] = _.uniqWith(options, _.isEqual);
                    }
                }
            }
            setFields([...tempFieldsForm]);
        }
    }, [dependencies, renderInc]);

    useEffect(() => {
        setOpen(false);
        setCancel(false);
        setAddInc(false);
    }, [closeAllModals]);

    useEffect(() => {
        if (formData && Object.keys(formData).length > 0) {
            setCustomLoading(true);
            let tempIncObj: any = {};
            Object.keys(formData).forEach(key => {
                if (incKeys.some((incKey: string) => incKey === key)) {
                    if (Array.isArray(formData[key])) {
                        if (formData[key].some(item => typeof item === 'object' && item.hasOwnProperty('SAP_MESSAGE'))) {
                            formData[key].sort((a: any, b: any) => {
                                return a.SAP_MESSAGE.localeCompare(b.SAP_MESSAGE);
                            });
                        } else if (formData[key].some(item => typeof item === 'object' && item.hasOwnProperty('name'))) {
                            formData[key].sort((a: any, b: any) => {
                                return a.name.localeCompare(b.name);
                            });
                        } else if (formData[key].some(item => typeof item === 'object' && item.hasOwnProperty('email'))) {
                            formData[key].sort((a: any, b: any) => {
                                return a.email.localeCompare(b.email);
                            });
                        } else if (formData[key].some(item => typeof item === 'object' && item.hasOwnProperty('SAP'))) {
                            formData[key].sort((a: any, b: any) => {
                                return a.SAP.SAP.localeCompare(b.SAP.SAP);
                            });
                        } else {
                            formData[key].sort((a: any, b: any) => {
                                return a.localeCompare(b);
                            });
                        }
                    }
                    tempIncObj[key] = formData[key];
                }
            });
            const typeRow = typesInc.filter(
                (type: any) => type.Title === currentTypeInc
            )[0];
            if (!typeRow) {
                setCustomLoading(false);
                return;
            }
            const idCurrentTypeInc = typeRow["ID"];
            let closedDate = (typeof formData.DateIncidents.startDate === "string" && new Date(formData.DateIncidents.startDate)) || formData.DateIncidents.startDate;
            if (formData.IncidentOption === 'Инцидент') {
                if (idCurrentTypeInc === incTypes.safe) { //Безопасность
                    const days = Number(params.find((param: any) => param.Key === "IncSafeDate")["Value"].trim());
                    closedDate = moment(closedDate).add(days, 'days').toDate();
                }
                if (idCurrentTypeInc === incTypes.e) { //Экология
                    const days = Number(params.find((param: any) => param.Key === "IncEnvDate")["Value"].trim());
                    closedDate = moment(closedDate).add(days, 'days').toDate();
                }
                if (idCurrentTypeInc === incTypes.q) { //Качество
                    if (formData.QAIncidentType === 'Инцидент по качеству') {
                        const days = Number(params.find((param: any) => param.Key === "IncQualityDate")["Value"].trim());
                        closedDate = moment(closedDate).add(days, 'days').toDate();
                    }
                    if (formData.QAIncidentType === 'Инцидент в процессе') {
                        const days = Number(params.find((param: any) => param.Key === "IncProcessDate")["Value"].trim());
                        closedDate = moment(closedDate).add(days, 'days').toDate();
                    }
                }
                if (idCurrentTypeInc === incTypes.m) { //Техобслуживание
                    const days = Number(params.find((param: any) => param.Key === "IncMDate")["Value"].trim());
                    closedDate = moment(closedDate).add(days, 'days').toDate();
                }
            }
            if (formData.IncidentOption === 'Несоответствие') {
                if (idCurrentTypeInc === incTypes.safe) { //Безопасность
                    const days = Number(params.find((param: any) => param.Key === "NSafeDate")["Value"].trim());
                    closedDate = moment(closedDate).add(days, 'days').toDate();
                }
                if (idCurrentTypeInc === incTypes.e) { //Экология
                    const days = Number(params.find((param: any) => param.Key === "NEnvDate")["Value"].trim());
                    closedDate = moment(closedDate).add(days, 'days').toDate();
                }
                if (idCurrentTypeInc === incTypes.q) { //Качество
                    const days = Number(params.find((param: any) => param.Key === "NQualityDate")["Value"].trim());
                    closedDate = moment(closedDate).add(days, 'days').toDate();
                }
                if (idCurrentTypeInc === incTypes.m) { //Техобслуживание
                    const days = Number(params.find((param: any) => param.Key === "NMDate")["Value"].trim());
                    closedDate = moment(closedDate).add(days, 'days').toDate();
                }
            }
            const sendData = {
                Questions: JSON.stringify(tempIncObj),
                TypeIncident: idCurrentTypeInc,
                TimeIncident: formData.TimeIncident,
                Responsible: formData.Responsible[0]["value"],
                ResponsibleEmail: formData.Responsible[0]["value"],
                Title: `${formData.IncidentOption}. ${formData.TypeIncident}.${(formData.QAIncidentType && ` ${formData.QAIncidentType}.`) || ""} От ${moment((typeof formData.DateIncidents.startDate === "string" && new Date(formData.DateIncidents.startDate)) || formData.DateIncidents.startDate).format('DD.MM.YYYY')}`,
                DateIncidents: (typeof formData.DateIncidents.startDate === "string" && new Date(formData.DateIncidents.startDate)) || formData.DateIncidents.startDate,
                DateIncidents2: (typeof formData.DateIncidents2.startDate === "string" && new Date(formData.DateIncidents2.startDate)) || formData.DateIncidents2.startDate,
                Location: formData.Location.id,
                Department: formData.Department.id,
                Region: formData.Region.id,
                Description: formData.Description.trim() + " ",
                AuthorEmail: currentUser.email,
                ClosedDate: closedDate,
                Status: incStatus.process, // В процессе
                ResponsibleDepartment:
                    (users[formData.Responsible[0]["value"]] &&
                        users[formData.Responsible[0]["value"]]["department"]) ||
                    "",
                Fixed:
                    formData.FixedField && formData.FixedField.id === "Да" ? true : false,
                ID: createIncID
            };

            updateItemRequest({
              listName: myTasksIncidentstListName,
              body: sendData,
            }).then((incID) => {
              setIncIDAdd(incID);
              setAddInc(true);
              setCustomLoading(false);
            });
        }
    }, [formData]);

    useEffect(() => {
        if (incQuestions.length > 0) {
            setFields([...incQuestions]);
            setRenderInc(true);
        }
    }, [incQuestions]);

    useEffect(() => {
        if (currentTypeInc && typesInc.length > 0) {
            setRenderInc(false);
            const idCurrentTypeInc = typesInc.filter((type: any) => type.Title === currentTypeInc)[0]['ID'];
            setCustomLoading(true);
            getItemsRequest({ listName: myTasksIncidentsQuestionsListName, filters: { TypeIncident: idCurrentTypeInc }, sortOrder: { name: 'Order0', asc: true } }).then((results) => {
                const tempIncQuestions = [...results.items];
                let incFieldsForm: any = [];
                incFieldsForm = [...incFieldsForm, ...[
                    {
                        type: 'date',
                        require: true,
                        key: 'DateIncidents',
                        default: currentFormData && Object.keys(currentFormData).length > 0 && currentFormData.DateIncidents || { startDate: new Date(), endDate: new Date() },
                        title: 'Дата регистрации несоответствия/инцидента',
                        minDate: moment(new Date()).subtract(7, 'days').toDate(),
                        maxDate: moment(new Date()).toDate(),
                        placeholder: 'дд.мм.гггг',
                        condition: null,
                        width: 'w-full'
                    },
                    {
                        type: 'date',
                        require: true,
                        key: 'DateIncidents2',
                        default: currentFormData && Object.keys(currentFormData).length > 0 && currentFormData.DateIncidents2 || { startDate: new Date(), endDate: new Date() },
                        title: 'Дата несоответсвия/инцидента',
                        maxDate: moment(new Date()).toDate(),
                        placeholder: 'дд.мм.гггг',
                        condition: null,
                        width: 'w-full'
                    },
                    {
                        type: 'time',
                        require: false,
                        key: 'TimeIncident',
                        title: 'Время несоответствия/инцидента',
                        placeholder: 'чч:мм',
                        condition: null,
                        width: 'w-full'
                    },
                    {
                        type: 'radio',
                        require: true,
                        title: 'Тип несоответствия/инцидента',
                        key: 'TypeIncident',
                        condition: null,
                        width: 'w-full'
                    }
                ]];
                tempIncQuestions.forEach((item) => {
                    if (item.Key === 'IncidentOption' || item.Key === 'QAIncidentType') {
                        incFieldsForm = [...incFieldsForm, {
                            type: item.TypeQuestion,
                            require: item.Require,
                            noticeAnswers: item.NoticeAnswers && JSON.parse(item.NoticeAnswers).filter((notice: any) => notice.TypeIncident === currentTypeInc).length > 0 && JSON.parse(item.NoticeAnswers).filter((notice: any) => notice.TypeIncident === currentTypeInc)[0]['Notice'] || null,
                            notice: item.Notice,
                            noticeIcon: item.Notice && true || false,
                            key: item.Key,
                            title: item.Title,
                            hide: item.DefaultHide,
                            width: "w-full",
                            optionsInputs: item.Options && item.Options.split(";").map(option => option.trim()) || [],
                            condition: item.Condition && JSON.parse(item.Condition)
                        }]
                    }
                });
                incFieldsForm = [...incFieldsForm, ...[
                    {
                        type: 'peoplePicker',
                        require: true,
                        single: true,
                        key: 'Responsible',
                        title: 'ФИО инициатора',
                        current: true,
                        condition: null,
                        placeholder: 'Введите имя или фамилию',
                        width: 'w-full'
                    },

                    {
                        type: 'select',
                        require: true,
                        key: 'Location',
                        title: 'Локация, где произошло несоответствие/инцидент',
                        placeholder: 'Не выбрано',
                        condition: null,
                        width: 'w-full'
                    },
                    {
                        type: 'select',
                        require: true,
                        key: 'Department',
                        title: 'Отдел, где произошло несоответствие/инцидент',
                        placeholder: 'Не выбрано',
                        condition: null,
                        width: 'w-full'
                    },
                    {
                        type: 'select',
                        require: true,
                        key: 'Region',
                        title: 'Участок, где произошло несоответствие/инцидент',
                        placeholder: 'Не выбрано',
                        condition: null,
                        width: 'w-full'
                    },
                    {
                        type: 'textArea',
                        key: 'Description',
                        require: true,
                        title: 'Описание',
                        condition: null,
                        noticeIcon: true,
                        notice: `<span class="w-full"><strong>Что?</strong> (Что случилось, в чем именно проблема?)<br/>
            <strong>Где?</strong> (Где именно проблема в продукте/процессе и где была обнаружена?) <br/>
            <strong>Когда?</strong> (Когда проблема началась, когда была обнаружена?) <br/>
            <strong>Как?</strong> (Есть ли стандарт и соблюдался ли он на момент возникновения проблемы?) <br/>
            <strong>Кто?</strong> (Кто обнаружил проблему?) <br/>
            <strong>Насколько велика проблема?</strong> (Количество затронутого продукта / минуты простоя, риски от проблемы)<span>`,
                        placeholder: 'ЧТО? (Что случилось, в чем именно проблема?) ГДЕ? (Где именно проблема в продукте/процессе и где была обнаружена?) КОГДА? (Когда проблема началась, когда была обнаружена?) КАК? (Есть ли стандарт и соблюдался ли он на момент возникновения проблемы?) КТО? (Кто обнаружил проблему?) НАСКОЛЬКО ВЕЛИКА ПРОБЛЕМА? (Количество затронутого продукта / минуты простоя, риски от проблемы)',
                        width: 'w-full'
                    }
                ]];
                tempIncQuestions.forEach((item) => {
                    if (item.Key !== 'IncidentOption' && item.Key !== 'QAIncidentType') {
                        if (item.TypeQuestion === 'select') {
                            incFieldsForm = [...incFieldsForm, {
                                type: item.TypeQuestion,
                                require: item.Require,
                                key: item.Key,
                                notice: item.Notice,
                                noticeIcon: item.Notice && true || false,
                                title: item.Title,
                                hide: item.DefaultHide,
                                width: 'w-full',
                                placeholder: 'Не выбрано',
                                condition: item.Condition && JSON.parse(item.Condition),
                                options: item.Options && item.Options.split(";").map(option => {
                                    return {
                                        id: option.trim(),
                                        name: option.trim()
                                    }
                                }) || []
                            }]
                        } else if (item.TypeQuestion === 'radio' || item.TypeQuestion === 'checkbox') {
                            incFieldsForm = [...incFieldsForm, {
                                type: item.TypeQuestion,
                                require: item.Require,
                                key: item.Key,
                                notice: item.Notice,
                                noticeIcon: item.Notice && true || false,
                                title: item.Title,
                                hide: item.DefaultHide,
                                width: 'w-full',
                                condition: item.Condition && JSON.parse(item.Condition),
                                optionsInputs: item.Options && item.Options.split(";").map(option => option.trim()) || []
                            }]
                        } else if (item.TypeQuestion === 'number' || item.TypeQuestion === 'input') {
                            incFieldsForm = [...incFieldsForm, {
                                type: item.TypeQuestion,
                                require: item.Require,
                                key: item.Key,
                                title: item.Title,
                                disabled: item.Disabled,
                                notice: item.Notice,
                                noticeIcon: item.Notice && true || false,
                                placeholder: 'Введите значение',
                                hide: item.DefaultHide,
                                width: 'w-full',
                                condition: item.Condition && JSON.parse(item.Condition),
                                default: item.Options
                            }]
                        } else if (item.TypeQuestion === "repeater") {
                            if (idCurrentTypeInc === incTypes.q) { //Качество
                                incFieldsForm = [...incFieldsForm, {
                                    type: item.TypeQuestion,
                                    key: item.Key,
                                    hide: item.DefaultHide,
                                    notice: item.Notice,
                                    noticeIcon: item.Notice && true || false,
                                    title: item.Title,
                                    condition: item.Condition && JSON.parse(item.Condition),
                                    fields: [
                                        {
                                            type: "autocomplete",
                                            require: item.Require,
                                            title: "SAP № технического места",
                                            key: "SAP",
                                            placeholder: "Начните вводить SAP",
                                            width: "w-full",
                                            searchApiField: "SAP",
                                            searchApiList: equipmentsListName,
                                            searchApiSelectFields: "ID,Title,SAP,Manufacturer,Model,TypeEquipment",
                                            searchApiFilterField: "",
                                            searchApiFilterFieldValue: "",
                                        },
                                        {
                                            type: "text",
                                            title: "Название оборудования",
                                            key: "Title",
                                            value: "",
                                            require: item.Require,
                                            width: "w-full",
                                        },
                                        {
                                            type: "text",
                                            title: "Производитель оборудования",
                                            key: "Manufacturer",
                                            value: "",
                                            require: item.Require,
                                            width: "w-full",
                                        },
                                        {
                                            type: "text",
                                            title: "Модель оборудования",
                                            key: "Model",
                                            value: "",
                                            require: item.Require,
                                            width: "w-full",
                                        },
                                        {
                                            type: "text",
                                            title: "Тип оборудования",
                                            key: "TypeEquipment",
                                            value: "",
                                            require: item.Require,
                                            width: "w-full",
                                        },
                                    ],
                                    width: "w-full",
                                    require: item.Require
                                }]
                            }
                            if (idCurrentTypeInc === incTypes.m) { //Техобслуживание
                                incFieldsForm = [...incFieldsForm, {
                                    type: item.TypeQuestion,
                                    key: item.Key,
                                    hide: item.DefaultHide,
                                    title: item.Title,
                                    notice: item.Notice,
                                    noticeIcon: item.Notice && true || false,
                                    condition: item.Condition && JSON.parse(item.Condition),
                                    fields: [
                                        {
                                            type: "input",
                                            key: "SAP_MESSAGE",
                                            require: item.Require,
                                            title: "SAP номер сообщения",
                                            placeholder: "Введите значение",
                                            width: "w-full",
                                        },
                                        {
                                            type: "autocomplete",
                                            require: item.Require,
                                            title: "SAP № технического места",
                                            key: "SAP",
                                            placeholder: "Начните вводить SAP",
                                            width: "w-full",
                                            searchApiField: "SAP",
                                            searchApiList: equipmentsListName,
                                            searchApiSelectFields: "ID,Title,SAP,Manufacturer,Model,TypeEquipment",
                                            searchApiFilterField: "",
                                            searchApiFilterFieldValue: "",
                                        },
                                        {
                                            type: "text",
                                            title: "Название оборудования",
                                            key: "Title",
                                            value: "",
                                            require: item.Require,
                                            width: "w-full",
                                        },
                                        {
                                            type: "text",
                                            title: "Производитель оборудования",
                                            key: "Manufacturer",
                                            value: "",
                                            require: item.Require,
                                            width: "w-full",
                                        },
                                        {
                                            type: "text",
                                            title: "Модель оборудования",
                                            key: "Model",
                                            value: "",
                                            require: item.Require,
                                            width: "w-full",
                                        },
                                        {
                                            type: "text",
                                            title: "Тип оборудования",
                                            key: "TypeEquipment",
                                            value: "",
                                            require: item.Require,
                                            width: "w-full",
                                        },
                                    ],
                                    width: "w-full",
                                    require: item.Require
                                }]
                            }
                        } else if (item.TypeQuestion === "textArea") {
                            incFieldsForm = [...incFieldsForm, {
                                type: item.TypeQuestion,
                                require: item.Require,
                                key: item.Key,
                                title: item.Title,
                                notice: item.Notice,
                                noticeIcon: item.Notice && true || false,
                                disabled: item.Disabled,
                                placeholder: 'Введите значение',
                                hide: item.DefaultHide,
                                width: 'w-full',
                                condition: item.Condition && JSON.parse(item.Condition),
                                default: item.Options
                            }]
                        }
                    }
                });
                setIncQuestions([...incFieldsForm]);
                setCustomLoading(false);
            });
        } else {
            setRenderInc(true);
        }
    }, [currentTypeInc, typesInc]);

    useEffect(() => {
        if (!addInc && incIDAdd) {
            localStorage.setItem('NEW_INC', incIDAdd.toString());
            if (localStorage.getItem('OpenAdd5WayCardForm')) {
                localStorage.setItem('OpenAdd5WayCardForm', '');
                let trigger: any;
                if (formData.TypeIncident) {
                    const idCurrentTypeInc = typesInc.filter((type: any) => type.Title === formData.TypeIncident)[0]['ID'];
                    if (idCurrentTypeInc === incTypes.safe) {
                        if (formData.IncidentOption === 'Инцидент') {
                            trigger = { name: 'Инцидент по Безопасности', id: incTrigger.safe }
                        }
                        if (formData.IncidentOption === 'Несоответствие') {
                            trigger = { name: 'Несоответствие по Безопасности', id: nTrigger.safe }
                        }
                    }
                    if (idCurrentTypeInc === incTypes.e) {
                        if (formData.IncidentOption === 'Инцидент') {
                            trigger = { name: 'Инцидент по Экологии', id: incTrigger.e }
                        }
                        if (formData.IncidentOption === 'Несоответствие') {
                            trigger = { name: 'Несоответствие по Экологии', id: nTrigger.e }
                        }
                    }
                    if (idCurrentTypeInc === incTypes.q) {
                        if (formData.IncidentOption === 'Инцидент') {
                            if (formData.QAIncidentType === 'Инцидент в процессе') {
                                trigger = { name: 'Инцидент в процессе', id: incTrigger.process }
                            }
                            if (formData.QAIncidentType === 'Инцидент по качеству') {
                                trigger = { name: 'Инцидент по Качеству', id: incTrigger.q }
                            }
                        }
                        if (formData.IncidentOption === 'Несоответствие') {
                            trigger = { name: 'Несоответствие по Качеству', id: nTrigger.q }
                        }
                    }
                    if (idCurrentTypeInc === incTypes.m) {
                        if (formData.IncidentOption === 'Инцидент') {
                            trigger = { name: 'Инцидент по Техобслуживанию', id: incTrigger.m }
                        }
                        if (formData.IncidentOption === 'Несоответствие') {
                            trigger = { name: 'Несоответствие по Техобслуживанию', id: nTrigger.m }
                        }
                    }
                }
                localStorage.setItem('default5WayCardDataInc', JSON.stringify({
                    Location: formData.Location,
                    Department: formData.Department,
                    Region: formData.Region,
                    Trigger: trigger
                }));
                if (formData.IncidentOption && formData.IncidentOption === 'Инцидент') {
                    navigate('/dashboard/3/deviation-reports');
                }
                if (formData.IncidentOption && formData.IncidentOption === 'Несоответствие') {
                    navigate('/dashboard/3/5-whys');
                }
            } else {
                const newSearchParams = new URLSearchParams(query);
                // Mobile: always open the mobile incident card modal.
                newSearchParams.delete("incidentCard");
                newSearchParams.delete("incidentCardMobile");
                newSearchParams.set("incidentCardMobile", incIDAdd.toString());
                setQuery(newSearchParams);
            }
            setFormData(null);
            setIncIDAdd(null);
        }
    }, [addInc]);

    useEffect(() => {
        if (renderInc && currentFormData) {
            const tempFieldsForm = [...fields];
            for (let i = 0; i < tempFieldsForm.length; i++) {
                const field = tempFieldsForm[i];
                if (field.key === 'DateIncidents' || field.key === 'DateIncidents2') {
                    tempFieldsForm[i]['default'] = currentFormData[field.key];
                }
                if (field.condition) {
                    let conditionObj: any = {};
                    Object.keys(field.condition).forEach((key: string) => {
                        if (typeof currentFormData[key] === 'object') {
                            if (currentFormData[key]['name'] === field.condition[key]) {
                                conditionObj[key] = true;
                            }
                        } else {
                            if (currentFormData[key] === field.condition[key]) {
                                conditionObj[key] = true;
                            }
                        }
                    });
                    if (Object.keys(field.condition).length === Object.keys(conditionObj).length) {
                        tempFieldsForm[i]['hide'] = false;
                    } else {
                        tempFieldsForm[i]['hide'] = true;
                    }
                }
            }
            setFields([...tempFieldsForm]);
        }
    }, [currentFormData, renderInc]);

    useEffect(() => {
        const tempFieldsForm = [...fields];
        let tempKeys: any = [];
        for (let i = 0; i < tempFieldsForm.length; i++) {
            const field = tempFieldsForm[i];
            if (!field.hide && (field.condition || field.key === 'IncidentOption' || field.key === 'QAIncidentType')) {
                tempKeys = [...tempKeys, field.key];
            }
        }
        setIncKeys([...tempKeys]);
    }, [fields]);

      useEffect(() => {
        if (open) {
          const sendData = {
            Title: `Временный инцидент/несоответствие`
          };
          addItemRequest({ listName: myTasksIncidentstListName, body: sendData }).then(
            (incID) => {
              console.log('Создали инцедент/несоответствие #: ', incID);
              setCreateIncID(incID);
            });
        }
      }, [open]);

      useEffect(() => {
        if (cancel) {
          setRemoveInc(true)
        }
        if (!cancel && removeInc) {
          deleteItemRequest({ listName: myTasksIncidentstListName, ID: createIncID }).then(() => {
            console.log('Удалили инцидент/несоответствие #: ', createIncID);
            setCreateIncID(0);
            setRemoveInc(false);
          });
        }
      }, [cancel]);


    return (
        <>
            {fromTaskCard ? (
                    <button type="button" className={`${taskCardButtonClassName} `} onClick={() => setOpen(true)}>
                      Инцидент/несоответствие
                    </button>
                  ) : (
                    <Button open={open} setOpen={setOpen} typeIcon="add" classBg="btn-dark" text="Создать новую форму" icon={true} />
                  )}

            <DrawerComponent setOpenCustomModal={setCancel} zIndex={zIndex} open={open} toggleDrawer={setOpen}>
                {customLoading &&
                    <LoadingOpBg />
                }
                <div className="flex flex-col p-[24px] shrink">
                    <h1 className="mb-8 text-black text-[16px]">Создание несоответствия</h1>
                    <Form
                        type="add_my_tasks_inc"
                        setFormData={setFormData}
                        fieldsForm={[...fields]}
                        setCurrentTypeInc={setCurrentTypeInc}
                        setCurrentFormData={setCurrentFormData}
                        setOpenCancelAddCard={setCancel}
                        openCancelAddCard={cancel}
                        defaultValues={defaultValues}
                        setDependenceFields={setDependenceFields}
                        incidentID={createIncID}
                    />
                </div>
            </DrawerComponent>

            <Modal zIndex={zIndex ? zIndex + 10 : 70} modalClassName="min-h-px px-[24px]" open={cancel} toggleDialog={setCancel}>
                <header className="pb-0">
                    <h2 className="text-[14px] leading-none">Вы действительно хотите отменить изменения?</h2>
                </header>

                {/* <div className="py-5">
                    <p>
                        При нажатии на “Отмена” возврат действий будет невозможен
                    </p>
                </div> */}

                <footer className="flex flex-col gap-2 w-full pt-[18px] mt-4">
                    <TGButton color="white" onClick={(e) => setCancel(false)}>
                        Закрыть
                    </TGButton>
                    <TGButton color="bluedark" onClick={(e) => setCloseAllModals(!closeAllModals)}>
                        Подтвердить отмену
                    </TGButton>
                </footer>
            </Modal>
            <Modal
                zIndex={zIndex ? zIndex + 10 : 70}
                modalClassName="min-h-px"
                open={addInc}
                toggleDialog={setAddInc}
                autoClose={autoCloseModal}
                onAutoClose={() => {
                    setCloseAllModals(!closeAllModals);
                }}
            >
                <header className="px-10 pb-4">
                    <h2>Вы успешно сохранили форму</h2>
                </header>

                <div className="px-10 py-5">
                    <p>
                        Форма сохранена со всеми изменениями
                    </p>
                </div>

                <footer className="flex justify-center w-full px-10 pt-10 mt-4 border-t">
                    <TGButton color="bluedark" onClick={(e) => setCloseAllModals(!closeAllModals)}>
                        Закрыть
                    </TGButton>
                </footer>
            </Modal>
        </>
    );
};

export default AddIncident;
